export const KeyColors = {
  blue: {
    l4: '#CFDFEF',
    l3: '#AEC9E5',
    l2: '#8DB2DA',
    l1: '#6C9CCF',
    DEFAULT: '#3B7BBF',
    d1: '#306299',
    d2: '#29507E',
    d3: '#224065',
    d4: '#1A2E4A',
    z3: '#272B39',
    z2: '#202533',
  },
  black: { DEFAULT: '#0F1423' },
  z: {
    0: '#0F1423',
    1: '#1A1F2D',
    2: '#202533',
    3: '#272B39',
    4: '#2E3340',
    5: '#353946',
    6: '#3B404C',
    7: '#434752',
    8: '#494E59',
    9: '#50545F',
    10: '#5B5F69',
  },
  grey: {
    l4: '#E0E1E3',
    l3: '#CACBCE',
    l2: '#B4B6BA',
    l1: '#9EA0A6',
    DEFAULT: '#878A91',
    d1: '#72747D',
    d2: '#5B5F69',
    d3: '#464A55',
    d4: '#313242',
  },
  white: { DEFAULT: '#FAFAFA' },
  red: { DEFAULT: '#ED1B2F' },
  yellow: { DEFAULT: '#FFDC2D' },
  orange: { DEFAULT: '#FF6F00' },
  green: { DEFAULT: '#558B2F' },
}

/**
 * @deprecated use semantic colors.
 * @see DaisyUI colors: https://daisyui.com/docs/colors/
 * @see Tailwind CSS colors: https://tailwindcss.com/docs/customizing-colors
 */
export function getColor(base: keyof typeof KeyColors, variant?: string): string {
  let color: string
  if (!variant) color = KeyColors[base]['DEFAULT']
  else color = KeyColors[base][variant]

  if (!color) throw new ReferenceError("The color doesn't exist")

  return color
}
